import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { me, signIn as apiSignIn, signOut as apiSignOut } from "@/lib/api";
import { toast } from "sonner";

const AuthContext = createContext({ user: null, loading: true, signIn: async () => {}, signOut: async () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("gmh_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const data = await me();
      setUser(data);
    } catch (e) {
      localStorage.removeItem("gmh_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = useCallback(async (email, name) => {
    const data = await apiSignIn(email, name);
    localStorage.setItem("gmh_token", data.token);
    setUser(data.user);
    toast.success(`Welcome, ${data.user.name}`);
    return data.user;
  }, []);

  const signOut = useCallback(async () => {
    try {
      await apiSignOut();
    } catch (e) {
      // Best-effort server-side signout; we always clear local state
      // afterwards regardless. Log so network failures don't disappear.
      // eslint-disable-next-line no-console
      console.warn("[AuthProvider] signOut request failed (clearing local state anyway):", e);
    }
    localStorage.removeItem("gmh_token");
    setUser(null);
    toast("Signed out");
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut, refresh }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
